// @flow
import React, { Component } from 'react';
import type { Node } from 'react';
// Helpers
import PropTypes from 'prop-types';
import hayPropTypes from 'proptypes/hayPropTypes';
import classNames from 'classnames';
// Style
import styles from 'themes/defaults/sass/components/Grid.scss';

/**
 *	Grid React presentational component.
 */
class Grid extends Component<*, *> {
  /**
   * Props implementation.
   */
  static propTypes = {
    isFluid: PropTypes.bool,
    className: PropTypes.string,
    children: hayPropTypes.notAllowChildrenOfTypes('Grid')
  };
  /**
   * defaultProps implementation.
   */
  static defaultProps: Object = {
    isFluid: false
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Node {
    const { children, isFluid, className } = this.props;

    if (!children) {
      return null;
    }

    const gridTypeClass = isFluid
      ? styles['container-fluid']
      : styles['container'];
    const gridClasses = classNames([className, gridTypeClass]);

    return <div className={gridClasses}>{children}</div>;
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/Common/Grid/Grid/index.js